/**
 * Web/PWA session rules (Plan AU M-8). Pure: no Capacitor imports, so node:test can load it.
 *
 * Native keeps the JWT token pair in the Keychain. The web build stores no token at all:
 * Foroba's httponly `suite_session` cookie carries auth, so an XSS cannot read it.
 */
import { apiErrorMessage } from './apiError.ts'

/** Keys older web builds wrote to localStorage; purged once at startup. */
export const LEGACY_TOKEN_KEYS = ['pfh_access_token', 'pfh_refresh_token'] as const

export interface AuthRoutes {
  login: string
  mfa: string
  logout: string
  credentials: RequestCredentials
}

export function authRoutes(native: boolean): AuthRoutes {
  return native
    ? { login: '/auth/token', mfa: '/auth/token/2fa', logout: '/auth/token/revoke', credentials: 'same-origin' }
    : { login: '/auth/login', mfa: '/auth/login/2fa', logout: '/auth/logout', credentials: 'include' }
}

export function purgeLegacyTokens(storage: Pick<Storage, 'removeItem'>): void {
  for (const k of LEGACY_TOKEN_KEYS) storage.removeItem(k)
}

export type CookieLoginOutcome =
  | { kind: 'session' }
  | { kind: 'mfa'; methods: string[] | undefined }
  | { kind: 'error'; message: string }

/** Foroba POST /auth/login answers 200 with either the user (cookie set) or an MFA challenge. */
export function classifyCookieLogin(
  status: number,
  body: { mfa_required?: boolean; methods?: string[]; detail?: unknown },
): CookieLoginOutcome {
  if (status !== 200) return { kind: 'error', message: apiErrorMessage(body, `Login failed (${status})`) }
  if (body.mfa_required) return { kind: 'mfa', methods: body.methods }
  return { kind: 'session' }
}
